"use client";

import dynamic from "next/dynamic";
import RegInput from "../Input/RegInput";
import ManualGroup from "../Input/ManualGroup";
import { useEffect, useRef, useState } from "react";
import { useManualVehicle } from "@/lib/hooks/useManualVehicle";

const Spinner = dynamic(() => import("@/components/common/Spinner"), {
  ssr: false,
});

const VehicleSelectionForm = ({
  t,
  selectedMake,
  selectedModel,
  hasManualLook,
  updatePageTitle,
  removeManualSelection,
}) => {
  const {
    data: { isFetching, control, optionsList, hasEngineOpts },
    methods: {
      register,
      handleSubmit,
      findUsingReg,
      fetchDetailByManual,
      handleDropdownSelection,
    },
  } = useManualVehicle({
    t,
    selectedMake,
    hasManualLook,
    selectedModel,
    updatePageTitle,
    isGlobalForm: true,
    isManualForm: true,
    removeManualSelection,
  });

  const contentRef = useRef(null);
  const [isManualOpen, setIsManualOpen] = useState(false);

  useEffect(() => {
    const { searchParams } = new URL(window.location.href);
    const hasManualFlow = searchParams.has("make") && searchParams.has("model");
    if (hasManualFlow) {
      setIsManualOpen(true);
    }
  }, [hasManualLook]);

  return (
    <div className="current-vehicle-box vehicle-selection-form">
      <form noValidate onSubmit={handleSubmit(findUsingReg)}>
        <div className="vehicle-form-container relative">
          {isFetching && (
            <div className="flex justify-center absolute w-full h-full top-0 z-[50] blur-backdrop">
              <Spinner />
            </div>
          )}

          <div className="flex xl:flex-row flex-col gap-12 xl:max-w-[400px]">
            <div className="left-section">
              <div className="regBoxContainer">
                <RegInput t={t} register={register} />
              </div>
              <button type="submit" className="green-btn">
                {t("button.find_parts")}
              </button>
            </div>

            <span className="separator-text flex justify-center items-center italic">
              {t("current_vehicle.or")}
            </span>
          </div>

          <button
            type="button"
            className="xs:hidden flex justify-between items-center mvl-header"
            onClick={() => setIsManualOpen(!isManualOpen)}
          >
            <div className="w-full text-left text-body-text-3-sb py-3 bg-gray-100 font-bold">
              Select Your Vehicle
            </div>
            <svg
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              className={isManualOpen ? "rotate-180" : ""}
            >
              <path
                d="M6 9.16211L12 15.1621L18 9.16211"
                stroke="#002F6E"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>

          <div
            ref={contentRef}
            className={`select-box-container flex xl:max-w-[calc(100%-412px)] xs:!max-h-max transition-all duration-300 ${
              isManualOpen
                ? "max-h-max"
                : "xs:max-h-max max-h-0 xs:overflow-visible overflow-hidden"
            }`}
            style={{
              maxHeight: isManualOpen
                ? (contentRef?.current?.scrollHeight || 0) + 200
                : 0,
            }}
          >
            <ManualGroup
              t={t}
              control={control}
              optionsList={optionsList}
              hasEngineOpts={hasEngineOpts}
              fromMakeAndModel={hasManualLook}
              finalSelection={fetchDetailByManual}
              handleChange={handleDropdownSelection}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default VehicleSelectionForm;
